export default "__VITE_ASSET__Dg8bgqRY__"